import React from 'react';
import FlyersListenPart1 from '../exercises/FlyersListenPart1';
import FlyersListenPart2 from '../exercises/FlyersListenPart2';
import FlyersListenPart3 from '../exercises/FlyersListenPart3';
import FlyersListenPart4 from '../exercises/FlyersListenPart4';
import FlyersListenPart5 from '../exercises/FlyersListenPart5';
import FlyersReadingPart1 from '../exercises/FlyersReadingPart1';
import FlyersReadingPart2 from '../exercises/FlyersReadingPart2';
import FlyersReadingPart3 from '../exercises/FlyersReadingPart3';
import FlyersReadingPart4 from '../exercises/FlyersReadingPart4';
import FlyersReadingPart5 from '../exercises/FlyersReadingPart5';
import FlyersReadingPart6 from '../exercises/FlyersReadingPart6';
import FlyersReadingPart7 from '../exercises/FlyersReadingPart7';
import MoversListenPart3 from '../exercises/MoversListenPart3';
import MoversReadingPart1 from '../exercises/MoversReadingPart1';
import MoversReadingPart2 from '../exercises/MoversReadingPart2';
import MoversReadingPart3 from '../exercises/MoversReadingPart3';
import MoversReadingPart4 from '../exercises/MoversReadingPart4';
import MoversReadingPart5 from '../exercises/MoversReadingPart5';
import MoversReadingPart6 from '../exercises/MoversReadingPart6';
import MoversReadingPart7 from '../exercises/MoversReadingPart7';
import MoversListenPart1 from '../exercises/MoversListenPart1';
import MoversListenPart2 from '../exercises/MoversListenPart2';
import MoversListenPart4 from '../exercises/MoversListenPart4';
import MoversListenPart5 from '../exercises/MoversListenPart5';
import StartersReadingPart1 from '../exercises/StartersReadingPart1';
import StartersReadingPart2 from '../exercises/StartersReadingPart2';
import StartersReadingPart3 from '../exercises/StartersReadingPart3';
import StartersReadingPart4 from '../exercises/StartersReadingPart4';
import StartersReadingPart5 from '../exercises/StartersReadingPart5';
import StartersReadingPart6 from '../exercises/StartersReadingPart6';
import StartersReadingPart7 from '../exercises/StartersReadingPart7';
import StartersListenPart1 from '../exercises/StartersListenPart1';
import StartersListenPart2 from '../exercises/StartersListenPart2';
import StartersListenPart3 from '../exercises/StartersListenPart3';
import StartersListenPart4 from '../exercises/StartersListenPart4';
import KetListenPart1 from '../exercises/KetListenPart1';
import KetListenPart2 from '../exercises/KetListenPart2';
import KetListenPart3 from '../exercises/KetListenPart3';
import KetListenPart4 from '../exercises/KetListenPart4';
import KetListenPart5 from '../exercises/KetListenPart5';
import KetReadingPart1 from '../exercises/KetReadingPart1';
import KetReadingPart2 from '../exercises/KetReadingPart2';
import KetReadingPart3a from '../exercises/KetReadingPart3a';
import KetReadingPart3b from '../exercises/KetReadingPart3b';
import KetReadingPart4 from '../exercises/KetReadingPart4';
import KetReadingPart5 from '../exercises/KetReadingPart5';
import KetReadingPart6 from '../exercises/KetReadingPart6';
import KetReadingPart7 from '../exercises/KetReadingPart7';
import KetReadingPart8 from '../exercises/KetReadingPart8';
import KetReadingPart9 from '../exercises/KetReadingPart9';
import Ket2ReadingMCQ from '../exercises/Ket2ReadingMCQ';
import ExerciseLearnPanel from '../full_mock_test/attempt/ExerciseLearnPanel';

// Exercise types where per-question tag icon is rendered INLINE inside the
// exercise component. For these, skip the aggregate panel below to avoid duplication.
const INLINE_TAG_PANEL_TYPES = new Set([
  'reading_writing_flyer_part_1',
  'reading_writing_flyer_part_2',
  'reading_writing_flyer_part_3',
  'reading_writing_flyer_part_4',
  'reading_writing_flyer_part_5',
  'reading_writing_flyer_part_6',
  'listen_flyer_part_1',
  'listen_flyer_part_2',
  'listen_flyer_part_3',
  'listen_flyer_part_4',
  'listen_flyer_part_5',
  'listen_mover_part_3',
  'listen_movers_part_3',
  'reading_writing_movers_part_1',
  'reading_writing_movers_part_2',
  'reading_writing_movers_part_3',
  'reading_writing_movers_part_4',
  'reading_writing_movers_part_5',
  'reading_writing_movers_part_6',
  'reading_writing_movers_part_7',
  'listen_movers_part_1',
  'listen_mover_part_1',
  'listen_movers_part_2',
  'listen_mover_part_2',
  'listen_movers_part_4',
  'listen_mover_part_4',
  'listen_movers_part_5',
  'listen_mover_part_5',
  'reading_writing_starters_part_1',
  'reading_writing_starters_part_2',
  'reading_writing_starters_part_3',
  'reading_writing_starters_part_4',
  'reading_writing_starters_part_5',
  'reading_writing_starters_part_6',
  'reading_writing_starters_part_7',
  'listen_starters_part_1',
  'listen_starters_part_2',
  'listen_starters_part_3',
  'listen_starters_part_4',
  'listen_ket_part_1',
  'listen_ket_part_2',
  'listen_ket_part_3',
  'listen_ket_part_4',
  'listen_ket_part_5',
  'reading_writing_ket_part_1',
  'reading_writing_ket_part_2',
  'reading_writing_ket_part_3a',
  'reading_writing_ket_part_3b',
  'reading_writing_ket_part_4',
  'reading_writing_ket_part_5',
  'reading_writing_ket_part_6',
  'reading_writing_ket_part_7',
  'reading_writing_ket_part_8',
  'reading_writing_ket_part_9',
  'listen_ket2_part_1',
  'listen_ket2_part_2',
  'listen_ket2_part_3',
  'listen_ket2_part_4',
  'listen_ket2_part_5',
  'reading_writing_ket2_part_1',
  'reading_writing_ket2_part_2',
  'reading_writing_ket2_part_3',
  'reading_writing_ket2_part_4',
  'reading_writing_ket2_part_5',
  'reading_writing_ket2_part_6',
  'reading_writing_ket2_part_7',
]);

const exerciseComponentMap = {
  'listen_flyer_part_1': FlyersListenPart1,
  'listen_flyer_part_2': FlyersListenPart2,
  'listen_flyer_part_3': FlyersListenPart3,
  'listen_flyer_part_4': FlyersListenPart4,
  'listen_flyer_part_5': FlyersListenPart5,
  'reading_writing_flyer_part_1': FlyersReadingPart1,
  'reading_writing_flyer_part_2': FlyersReadingPart2,
  'reading_writing_flyer_part_3': FlyersReadingPart3,
  'reading_writing_flyer_part_4': FlyersReadingPart4,
  'reading_writing_flyer_part_5': FlyersReadingPart5,
  'reading_writing_flyer_part_6': FlyersReadingPart6,
  'reading_writing_flyer_part_7': FlyersReadingPart7,
  'listen_mover_part_3': MoversListenPart3,
  'listen_movers_part_3': MoversListenPart3,
  'reading_writing_movers_part_1': MoversReadingPart1,
  'reading_writing_movers_part_2': MoversReadingPart2,
  'reading_writing_movers_part_3': MoversReadingPart3,
  'reading_writing_movers_part_4': MoversReadingPart4,
  'reading_writing_movers_part_5': MoversReadingPart5,
  'reading_writing_movers_part_6': MoversReadingPart6,
  'reading_writing_movers_part_7': MoversReadingPart7,
  'listen_movers_part_1': MoversListenPart1,
  'listen_mover_part_1': MoversListenPart1,
  'listen_movers_part_2': MoversListenPart2,
  'listen_mover_part_2': MoversListenPart2,
  'listen_movers_part_4': MoversListenPart4,
  'listen_mover_part_4': MoversListenPart4,
  'listen_movers_part_5': MoversListenPart5,
  'listen_mover_part_5': MoversListenPart5,
  'reading_writing_starters_part_1': StartersReadingPart1,
  'reading_writing_starters_part_2': StartersReadingPart2,
  'reading_writing_starters_part_3': StartersReadingPart3,
  'reading_writing_starters_part_4': StartersReadingPart4,
  'reading_writing_starters_part_5': StartersReadingPart5,
  'reading_writing_starters_part_6': StartersReadingPart6,
  'reading_writing_starters_part_7': StartersReadingPart7,
  'listen_starters_part_1': StartersListenPart1,
  'listen_starters_part_2': StartersListenPart2,
  'listen_starters_part_3': StartersListenPart3,
  'listen_starters_part_4': StartersListenPart4,
  'listen_ket_part_1': KetListenPart1,
  'listen_ket_part_2': KetListenPart2,
  'listen_ket_part_3': KetListenPart3,
  'listen_ket_part_4': KetListenPart4,
  'listen_ket_part_5': KetListenPart5,
  'reading_writing_ket_part_1': KetReadingPart1,
  'reading_writing_ket_part_2': KetReadingPart2,
  'reading_writing_ket_part_3a': KetReadingPart3a,
  'reading_writing_ket_part_3b': KetReadingPart3b,
  'reading_writing_ket_part_4': KetReadingPart4,
  'reading_writing_ket_part_5': KetReadingPart5,
  'reading_writing_ket_part_6': KetReadingPart6,
  'reading_writing_ket_part_7': KetReadingPart7,
  'reading_writing_ket_part_8': KetReadingPart8,
  'reading_writing_ket_part_9': KetReadingPart9,
  // A2 Key for Schools (2020 format) — new "ket2" types reuse KET renderers
  'listen_ket2_part_1': KetListenPart1,
  'listen_ket2_part_2': KetListenPart4,
  'listen_ket2_part_3': KetListenPart3,
  'listen_ket2_part_4': KetListenPart3,
  'listen_ket2_part_5': KetListenPart2,
  'reading_writing_ket2_part_1': Ket2ReadingMCQ,
  'reading_writing_ket2_part_2': Ket2ReadingMCQ,
  'reading_writing_ket2_part_3': Ket2ReadingMCQ,
  'reading_writing_ket2_part_4': KetReadingPart5,
  'reading_writing_ket2_part_5': KetReadingPart7,
  'reading_writing_ket2_part_6': KetReadingPart9,
  'reading_writing_ket2_part_7': KetReadingPart9,
};

const FocusedExerciseView = ({ exercise, attemptId, isReviewMode, showHint, fillHintSignal, zoomLevel, sharedColor, setSharedColor }) => {
  if (!exercise) {
    return <p>Loading exercise...</p>;
  }

  const ExerciseComponent = exerciseComponentMap[exercise.layout_type || exercise.type];

  if (!ExerciseComponent) {
    return (
      <div>
        <div className="error-message">Error: Unsupported exercise type "{exercise.type}"</div>
        <pre>{JSON.stringify(exercise, null, 2)}</pre>
      </div>
    );
  }

  const showAggregatePanel = isReviewMode && !INLINE_TAG_PANEL_TYPES.has(exercise.layout_type || exercise.type);

  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <ExerciseComponent
        exerciseData={exercise}
        attemptId={attemptId}
        exerciseId={exercise.id}
        isReviewMode={isReviewMode}
        showHint={showHint}
        fillHintSignal={fillHintSignal}
        zoomLevel={zoomLevel}
        sharedColor={sharedColor}
        setSharedColor={setSharedColor}
      />
      {showAggregatePanel && (
        <div style={{ padding: '0 16px 24px' }}>
          <ExerciseLearnPanel questions={exercise?.questions} isReviewMode={isReviewMode} />
        </div>
      )}
    </div>
  );
};

export default FocusedExerciseView;
